import React, { useEffect, useState } from 'react';
import VendorModel from './models/VendorModel';
import VendorDetailsFields from './VendorDetailsFields';

function AddVendor({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new VendorModel());

  useEffect(() => {
    const initial = new VendorModel();
    if (onLoad) onLoad(initial);
    if (sendDataToParent) sendDataToParent(initial);
  }, []);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <VendorDetailsFields formData={formData} sendDataToParent={handleData} />
    </div>
  );
}

export default AddVendor;
